import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "flex items-center justify-center h-20 border-b border-gray-200/50 dark:border-gray-700/50 bg-gradient-to-r from-primary-bg/50 via-primary-bg/30 to-transparent dark:from-primary-dark-bg/30 dark:via-primary-dark-bg/20 dark:to-transparent backdrop-blur-sm" }
const _hoisted_3 = { class: "flex items-center justify-center space-x-2 px-2 w-full" }
const _hoisted_4 = { class: "h-full w-full flex items-center justify-center flex-shrink-0" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex-1 px-4 py-6 space-y-2 overflow-y-auto" }
const _hoisted_7 = {
  key: 0,
  class: "absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b from-primary via-primary-hover to-primary dark:from-primary-dark dark:via-primary-dark-hover dark:to-primary-dark rounded-r-full shadow-lg shadow-primary/50 dark:shadow-primary-dark/50"
}
const _hoisted_8 = { class: "p-4 border-t border-gray-200/50 dark:border-gray-700/50 whitespace-nowrap transition-all duration-300" }
const _hoisted_9 = { class: "flex items-center justify-center space-x-2 text-xs text-slate-500 dark:text-slate-400" }

import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getNavigationItems } from '@/router'

// Props & Emits

export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
    isOpen: { type: Boolean },
    isCollapsed: { type: Boolean, default: false }
  },
  emits: ["update:isOpen"],
  setup(__props: any, { emit: __emit }) {

// Imports
const props = __props

const emit = __emit

// Composables
const route = useRoute()
const router = useRouter()

// Computed Properties
// const appTitle = computed(() => process.env.VUE_APP_TITLE || 'PLANET Home Healthcare')
const publicPath = computed(() => process.env.BASE_URL || '/')
const navigation = computed(() => getNavigationItems(router.options.routes))


// Methods
const isActive = (path: string) => route.path === path
const toggleSidebar = () => emit('update:isOpen', !props.isOpen)


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("aside", {
      class: _normalizeClass(["fixed inset-y-0 left-0 z-50 glass border-r border-gray-200/50 dark:border-gray-700/50 shadow-elegant-lg transform transition-all duration-300 ease-out lg:translate-x-0", [
      __props.isCollapsed ? 'w-20' : 'w-64',
      !__props.isOpen ? '-translate-x-full' : 'translate-x-0'
    ]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: `${publicPath.value}images/main-logo2.png`,
                alt: "Logo",
                class: _normalizeClass(["w-full h-full object-contain", [__props.isCollapsed ? '' : 'px-4']])
              }, null, 10, _hoisted_5)
            ])
          ])
        ]),
        _createElementVNode("nav", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.to,
              to: item.to,
              title: __props.isCollapsed ? item.name : undefined,
              class: _normalizeClass(["group flex items-center text-slate-700 dark:text-slate-300 rounded-xl transition-all duration-300 ease-out relative overflow-hidden", [
            __props.isCollapsed ? 'justify-center px-2 py-3' : 'px-4 py-3',
            {
              'bg-gradient-to-r from-primary/10 via-primary/5 to-transparent dark:from-primary-dark/20 dark:via-primary-dark/10 dark:to-transparent text-primary dark:text-primary-dark shadow-sm': isActive(item.to),
              'hover:bg-gray-100/50 dark:hover:bg-gray-700/30': !isActive(item.to)
            }
          ]])
            }, {
              default: _withCtx(() => [
                (isActive(item.to))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex items-center space-x-3 relative z-10 w-full", { 'justify-center space-x-0': __props.isCollapsed }])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex items-center justify-center w-10 h-10 rounded-xl transition-all duration-300 ease-out", {
                'bg-gradient-to-br from-primary/20 to-primary/10 dark:from-primary-dark/30 dark:to-primary-dark/20 shadow-sm': isActive(item.to),
                'bg-gray-100/50 dark:bg-gray-700/30 group-hover:bg-gray-200/50 dark:group-hover:bg-gray-600/30': !isActive(item.to)
              }])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass([
                  'w-5 h-5 flex-shrink-0 transition-all duration-300 group-hover:scale-110',
                  isActive(item.to) 
                    ? 'text-primary dark:text-primary-dark' 
                    : 'text-slate-500 dark:text-slate-400 group-hover:text-slate-700 dark:group-hover:text-slate-200'
                ])
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-full h-full" }))
                    ], 2)
                  ], 2),
                  _withDirectives(_createElementVNode("span", { class: "text-sm font-semibold ml-2 whitespace-nowrap transition-all duration-300" }, _toDisplayString(item.name), 513), [
                    [_vShow, !__props.isCollapsed]
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["absolute inset-0 opacity-0 group-hover:opacity-100 bg-gradient-to-r from-primary/5 via-primary/8 to-primary/5 dark:from-primary-dark/5 dark:via-primary-dark/8 dark:to-primary-dark/5 transition-all duration-300 rounded-xl", { 'opacity-0': isActive(item.to) }])
                }, null, 2)
              ]),
              _: 2
            }, 1032, ["to", "title", "class"]))
          }), 128))
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, "© " + _toDisplayString(new Date().getFullYear()), 1),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "w-1 h-1 rounded-full bg-secondary-text/30 dark:bg-secondary-dark-text/30" }, null, -1)),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "Developed by Proweaver", -1))
          ])
        ], 512), [
          [_vShow, !__props.isCollapsed]
        ])
      ])
    ], 2),
    (__props.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-40 bg-black/60 backdrop-blur-md lg:hidden transition-opacity duration-300",
          onClick: toggleSidebar
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})